const MaterializeTabSelectDirective = function ($timeout) {
    return function (scope, element, attrs) {
        if (attrs.materializeTabSelect) {
            scope.$watch(attrs.materializeTabSelect, function (newVal) {
                if (newVal && attrs.href.indexOf(newVal) != -1) {
                    $timeout(function () {
                        element.click();
                    });
                }
            });
        }
    }
};

MaterializeTabSelectDirective.$inject = ["$timeout"];

export { MaterializeTabSelectDirective };